
import AccountAddressEdit from '~/pages/_lang/account/delivery/edit/_id'
export default AccountAddressEdit
